import { Component, Input } from "@angular/core";

import { DialogRef, ModalComponent, CloseGuard } from "ngx-modialog-7";
import { BSModalContext } from "ngx-modialog-7/plugins/bootstrap";
import { ApplicationModel } from "app/core/models/application.model";

export class DialogModalContext extends BSModalContext {
	public title: string;
	public body: string;
	public footer: string;
}

@Component({
	selector: "modal-content",
	styleUrls: ["./dialog-modal-popup.directive.css"],
	template: `<div *ngIf="context.isMaxIdlePopup" class="popup-inner">
		<div
			class="con-overlay"
			[ngClass]="textDirection == 'rtl' ? 'rightDirection' : 'leftDirection'"
		>
			<div class="popup-title">
				<h3 class="title" [innerHTML]="context.title"></h3>
			</div>
			<h4 class="popup-body-text" [innerHTML]="context.body"></h4>
		</div>
		<div class="clearfix"></div>
	</div>`,
})
export class DialogModal
	implements CloseGuard, ModalComponent<DialogModalContext>
{
	context: DialogModalContext;

	constructor(public dialog: DialogRef<DialogModalContext>) {
		this.context = dialog.context;
		dialog.setCloseGuard(this);
	}

	beforeDismiss(): boolean {
		return true;
	}

	beforeClose(): boolean {
		return false;
	}

	public close() {
		this.dialog.close();
	}
	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}
}
